// Hardcoded allowlist: people who get FULL access to the Backlog + Feedback admin
// pages (view AND mutate) without holding an admin/management role. They reach the
// Beheer panel but see ONLY the Feedback tab (Feedback | Pipeline | Backlog).
// Mirrors BACKLOG_FEEDBACK_ADMINS in backend/config/backlogAccess.js — keep in sync.
export const BACKLOG_FEEDBACK_ADMINS = ['ton@fullframe.nl'];

// @full-frame.nl and @fullframe.nl are the same person (Ton/Pepijn use the dash-variant).
export const normalizeEmail = (e) =>
  (e || '').toLowerCase().trim().replace(/@full-frame\.nl$/, '@fullframe.nl');

export const canAccessBacklogFeedback = (email) =>
  BACKLOG_FEEDBACK_ADMINS.includes(normalizeEmail(email));
